import { useQuery } from '@tanstack/react-query';

export const usePurchaseData = (sub, accessKey) => 
  useQuery({
    queryKey: ['purchase-data', sub],
    queryFn: async () => {
      if (!sub || !accessKey) {
        throw new Error('Subscription ID and access key are required');
      }

      const response = await fetch(`${import.meta.env.VITE_API_URL}/purchase-details?sub=${sub}`, {
        headers: {
          'Authorization': `Bearer ${accessKey}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching purchase data');
      }

      const data = await response.json();
      return data;
    },
    enabled: !!sub && !!accessKey // Only run the query when both sub and accessKey are available
  });